<template>
    <div id="app">
        <!-- <img src="./assets/logo.png"> -->
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'app'
}
</script>



// WEBPACK FOOTER //
// src/App.vue